import { PROGRAM_NAMES } from './constants';

export const getConsecutiveActiveLevel = (levels = []) => {
  const activated = new Set(
    (levels || []).filter((item) => item?.isActivated).map((item) => Number(item.levelNumber)),
  );

  let level = 0;
  while (activated.has(level + 1)) {
    level += 1;
  }
  return level;
};

export const findNextMatrixLevel = async (matrixContract, user, isX2) => {
  if (!user || !matrixContract) return null;

  for (let level = 1; level <= 15; level++) {
    const isActive = isX2
      ? await matrixContract.usersActiveX2Levels(user, level)
      : await matrixContract.usersActiveX4Levels(user, level);
    if (!isActive) {
      return level;
    }
  }

  return null;
};

export const nextLevelToMaxActive = (nextLevel) => {
  if (nextLevel == null) return 15;
  return Math.max(0, nextLevel - 1);
};

export const MAIN_BG_COLOR = {
  [PROGRAM_NAMES.MATRIX_X2X4]: 'bg-primary-500',
  [PROGRAM_NAMES.MATRIX_USDT]: 'bg-main-usdt',
};

export const MAIN_TEXT_COLOR = {
  [PROGRAM_NAMES.MATRIX_X2X4]: 'text-primary-500',
  [PROGRAM_NAMES.MATRIX_USDT]: 'text-main-usdt',
};

export const NEXT_ACTIVATE_BG_CLASS = {
  [PROGRAM_NAMES.MATRIX_X2X4]: 'level-activating-bg',
  [PROGRAM_NAMES.MATRIX_USDT]: 'level-activating-usdt-bg',
};
